(function () {
  'use strict';

  /* ── 1. Hover open / close ─────────────────────────────────────────── */

  const menuItems = document.querySelectorAll('.header__menu_li.menu__item_has_children');

  menuItems.forEach((item) => {
  const details  = item.querySelector('details');
  const summary  = item.querySelector('summary');
  if (!details || !summary) return;

  let closeTimer = null;

  const openMenu = () => {
    clearTimeout(closeTimer);
    details.setAttribute('open', '');
    summary.setAttribute('aria-expanded', 'true');
  };

  const scheduleClose = () => {
    clearTimeout(closeTimer);
    closeTimer = setTimeout(() => {
      details.removeAttribute('open');
      summary.setAttribute('aria-expanded', 'false');
    }, 150);
  };

  // Open on entering the <li>
  item.addEventListener('mouseenter', openMenu);
  item.addEventListener('mouseleave', scheduleClose);

  // Keep open when cursor is inside the dropdown
  const dropdown = details.querySelector(
    '.header__mega_menu, .mega__menu--tabbed, .mega__menu--level, .mega__menu--brands, .header__sub_menu'
  );

  if (dropdown) {
    dropdown.addEventListener('mouseenter', () => clearTimeout(closeTimer));
    dropdown.addEventListener('mouseleave', scheduleClose);
  }

  // Click summary → navigate
  summary.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    const href = summary.dataset.href;
    if (href && details.hasAttribute('open')) {
      window.location.href = href;
    }
  });
});


  /* ── 2. Tab switching inside .mega__menu--tabbed ───────────────────── */

  /**
   * Activate a tab inside a tabbed mega menu.
   * @param {HTMLElement} megaMenu  - .mega__menu--tabbed wrapper
   * @param {string}      targetKey - the data-tab-target / data-tab-panel value
   */
  function activateTab(megaMenu, targetKey) {
    /* Nav links */
    megaMenu.querySelectorAll('.mega__tabbed--nav-link').forEach((link) => {
      const isTarget = link.dataset.tabTarget === targetKey;
      link.classList.toggle('is-active', isTarget);
    });

    /* Panels */
    megaMenu.querySelectorAll('.mega__tabbed--panel').forEach((panel) => {
      const isTarget = panel.dataset.tabPanel === targetKey;
      panel.classList.toggle('is-active', isTarget);
    });
  }

  /*
   * Count grid items per panel and set data-count so CSS can adjust flex-basis.
   * Called once on page load.
   */
  function stampGridCounts() {
    document.querySelectorAll('.mega__tabbed--grid').forEach((grid) => {
      const count = grid.querySelectorAll('.mega__tabbed--item').length;
      if (count) grid.dataset.count = count;
    });
  }

  function initTabbedMenus() {
    document.querySelectorAll('.mega__menu--tabbed').forEach((megaMenu) => {
      /* Ensure first tab is active on every open */
      const parentLi = megaMenu.closest('.header__menu_li');
      if (parentLi) {
        const details = parentLi.querySelector('details');
        if (details) {
          const observer = new MutationObserver(() => {
            if (details.hasAttribute('open')) {
              const firstLink = megaMenu.querySelector('.mega__tabbed--nav-link');
              if (firstLink) activateTab(megaMenu, firstLink.dataset.tabTarget);
            }
          });
          observer.observe(details, { attributes: true, attributeFilter: ['open'] });
        }
      }

      /* Tab switching on mouseenter */
      megaMenu.querySelectorAll('.mega__tabbed--nav-link').forEach((link) => {
        link.addEventListener('mouseenter', () => {
          activateTab(megaMenu, link.dataset.tabTarget);
        });

        /* Also handle focus (keyboard accessibility) */
        link.addEventListener('focus', () => {
          activateTab(megaMenu, link.dataset.tabTarget);
        });
      });
    });
  }

  stampGridCounts();
  initTabbedMenus();


  /* ── 3. Keyboard accessibility – Escape closes open menu ───────────── */

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;

    const openDetails = document.querySelector(
      '.header__menu_li.menu__item_has_children details[open]'
    );
    if (openDetails) {
      openDetails.removeAttribute('open');
      openDetails.querySelector('summary')?.focus();
    }
  });

})();